// extracted by mini-css-extract-plugin
module.exports = {"clubInfo":"ClubInfo_clubInfo__ZMLoh","clubInfoItem":"ClubInfo_clubInfoItem__H9f_p","step":"ClubInfo_step__CWXUy","title":"ClubInfo_title__pJSVC","text":"ClubInfo_text__kJvc7"};